export default {
    consent_page_title: "Kevi | Autorizar agente de suporte",
    consent_title: "Autorizar agente de suporte",
    consent_logged_in_as: "Conectado como <strong>{0}</strong>.",
    consent_question: "Autorizar o WhatsApp <strong>{0}</strong> a consultar dados da conta <strong>{1}</strong>?",
    consent_confirm: "Autorizar",
    consent_success_title: "Autorização concluída",
    consent_success_subtitle: "O agente de suporte já pode consultar os dados desta conta para este WhatsApp.",
    consent_invalid_title: "Link inválido ou expirado",
    consent_invalid_subtitle: "Solicite um novo link de autorização pelo atendimento.",
    consent_missing_request: "Link de autorização incompleto.",
    consent_confirm_error: "Não foi possível concluir a autorização. Tente novamente.",
    manage_page_title: "Kevi | Autorizações do agente",
    manage_title: "Autorizações do agente de suporte",
    manage_description: "WhatsApps autorizados a consultar dados desta conta via agente de suporte.",
    manage_empty_title: "Nenhuma autorização ainda",
    manage_empty: "Nenhuma autorização ativa para agentes de suporte.",
    manage_address: "Endereço",
    manage_authorizer: "Autorizado por",
    manage_last_used: "Último uso",
    manage_actions: "Ações",
    manage_revoke: "Revogar",
    manage_revoke_confirm: "Revogar esta autorização? O agente deixará de consultar dados desta conta para este WhatsApp.",
    manage_revoke_success: "Autorização revogada com sucesso.",
    manage_revoke_error: "Não foi possível revogar a autorização.",
};
